import { defineMessage } from 'services/localization';

export const messages = {
    paymentSummary: defineMessage('payment_summary'),
    total: defineMessage('total'),
    totalPaid: defineMessage('total_paid'),
    remaining: defineMessage('remaining'),
    pay: defineMessage('pay_amount'),
    order: defineMessage('order'),
    bill: defineMessage('bill'),
    dueDate: defineMessage('due_date'),
    amountDue: defineMessage('amount_due'),
    amount: defineMessage('amount'),
    status: defineMessage('status_1'),
    ready: defineMessage('ready'),
    payInfo: defineMessage('you_are_paying_amount_for_the_friendlyname'),
};
